module.exports = __webpack_public_path__ + "static/media/id.63108c70.svg";